// @ts-ignore
import content from './md/true-cost-of-missed-lead.md';

export const meta = {
  slug: 'true-cost-of-missed-lead',
  title: 'The True Cost of a Missed Lead: Why Response Time Is Your Biggest Revenue Driver',
  excerpt: 'Speed wins. Learn how much money walks out the door when leads don\'t get a timely response, and how to fix it.',
  date: 'January 2025',
  readTime: '8 min read',
  image: '/docs/true-cost-of-missed-lead/header.png'
};

export { content };
